import React, { useState } from "react";

const Projects = () => {
  const [activeFilter, setActiveFilter] = useState("All");

  const projects = [
    {
      id: 1,
      title: "Corporate Website",
      category: "Web Development",
      img: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1350&q=80",
      desc: "A responsive business website built with React and Tailwind CSS.",
    },
    {
      id: 2,
      title: "E-Commerce Platform",
      category: "Web Development",
      img: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=1350&q=80",
      desc: "A modern online store with cart and payment integration.",
    },
    {
      id: 3,
      title: "Brand Identity Design",
      category: "Branding",
      img: "https://images.unsplash.com/photo-1558655146-9f40138edfeb?auto=format&fit=crop&w=1350&q=80",
      desc: "Logo and complete brand identity for a tech startup.",
    },
    {
      id: 4,
      title: "Mobile App UI",
      category: "UI/UX Design",
      img: "https://images.unsplash.com/photo-1558655146-d09347e92766?auto=format&fit=crop&w=1350&q=80",
      desc: "Clean and minimal mobile app user interface design.",
    },
  ];


  const filters = ["All", "Web Development", "UI/UX Design", "Branding"];

  const filteredProjects =
    activeFilter === "All"
      ? projects
      : projects.filter((p) => p.category === activeFilter);

  return (
    <div className="pt-24 px-6 md:px-12">
      {/* Page Header */}
      <section className="text-center mb-16">
        <h1 className="text-4xl font-bold text-white mb-4">Our Projects</h1>
        <p className="text-white  max-w-2xl mx-auto">
          Here’s a selection of our latest work — each project reflects our passion for
          design and commitment to delivering innovative digital solutions.
        </p>
      </section>

      {/* Filter Buttons */}
      <div className="flex flex-wrap justify-center gap-4 mb-10">
        {filters.map((filter) => (
          <button
            key={filter}
            onClick={() => setActiveFilter(filter)}
            className={`px-5 py-2 rounded-full border text-sm font-medium transition-all duration-300 ${activeFilter === filter
                ? "bg-[#030303] text-white border-blue-600"
                : "text-white border-gray-300 hover:bg-blue-50"
              }`}
          >
            {filter}
          </button>
        ))}
      </div>

      {/* Projects Grid */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
        {filteredProjects.map((project) => (
          <div
            key={project.id}
            className="bg-white rounded-2xl shadow hover:shadow-xl transition-all duration-300 overflow-hidden group"
          >
            <div className="relative">
              <img
                src={project.img}
                alt={project.title}
                className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <p className="text-white text-sm font-medium">View Details</p>
              </div>
            </div>
            <div className="p-5">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {project.title}
              </h3>
              <p className="text-gray-600 text-sm mb-3">{project.desc}</p>
              <span className="inline-block text-blue-600 text-sm font-medium">
                {project.category}
              </span>
            </div>
          </div>
        ))}
      </div>
      {/* CTA Section */}
      <section className="bg-[#030303] text-white text-center py-16 rounded-2xl mb-10">
        <h2 className="text-3xl font-bold mb-4">
          Want to build your next project with us?
        </h2>
        <p className="mb-6 text-lg">
          Let’s collaborate and bring your ideas to life.
        </p>
        <a
          href="/contact"
          className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-slate-600 transition-all duration-300"
        >
          Contact Us
        </a>
      </section>
    </div>
  );
};
export default Projects;
